import React from "react";
import { List, Typography } from "antd";
import { OpportunityRecord } from "./types";

const { Text } = Typography;

interface OpportunityListItemProps {
  project: OpportunityRecord;
  isSelected: boolean;
  onSelect: (tenderId: string) => void;
}

const OpportunityListItem = React.memo<OpportunityListItemProps>(
  ({ project, isSelected, onSelect }) => {
    const formatDate = (dateString: string) => {
      return new Date(dateString).toLocaleDateString("en-GB", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    };

    return (
      <List.Item
        className={`cursor-pointer border-b border-gray-100 last:border-b-0 transition-colors ${
          isSelected ? "bg-blue-50 hover:bg-blue-100" : "hover:bg-gray-50"
        }`}
        style={{ padding: "12px 16px" }}
        onClick={() => onSelect(project.tenderId)}
      >
        <List.Item.Meta
          title={
            <div className="flex items-center gap-2 mb-1">
              <Text strong className="text-gray-900">
                {project.tender || "Unnamed Project"}
              </Text>
              
            </div>
          }
          description={
            <div>
              {project.no && (
                <Text className="text-gray-500 block mb-1 text-xs">
                  Opportunity No: {project.no}
                </Text>
              )}
              <Text className="text-gray-600 block mb-1">
                Client: {project.client || "Not specified"}
              </Text>
              {project.siteAddress && (
                <Text className="text-gray-500 block mb-1 text-xs">
                  Site: {project.siteAddress}
                </Text>
              )}
              {project.region && (
                <Text className="text-gray-500 block mb-1 text-xs">
                  Region: {project.region}
                </Text>
              )}
              <Text className="text-gray-400 text-xs">
                Created: {formatDate(project.creationDate)} • Modified:{" "}
                {formatDate(project.lastUpdateDate)}
              </Text>
            </div>
          }
        />
      </List.Item>
    );
  }
);

OpportunityListItem.displayName = "OpportunityListItem";

export default OpportunityListItem;
